import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { reducers } from '../store';
import { AuthEffect } from '../store/auth/effects.auth';
import { BaseEffect } from '../store/base/effects.base';
import { routes } from './app.routes';
import { httpClientInterceptor } from './core/auth/interceptors/http.interceptor';
import { requestDuplicatePreventionInterceptor } from './core/auth/interceptors/request-deduplication.interceptor';
import { loaderInterceptor } from './core/components/loader/loader.interceptor';
import { environment } from 'src/environments/environment';
import { ProviderEnvConfigService } from './shared/services/provider-env-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    ProviderEnvConfigService({
      env: environment.environmentType,
      apiUrl: environment.apiUrl,
      ridesCollection: environment.ridesCollection,
      emergenciesCollection: environment.emergenciesCollection,
      adrAdminUrl: environment.adrAdminUrl,
      production: environment.production,
      partnerCollection: environment.partnerCollection,
      mapDetailsCollection: environment.mapDetailsCollection,
      conversationsCollection: environment.conversationsCollection,
      isRunAsLibrary: false,
      isLocal: environment.isLocal,
      rideMapZoomLevel: environment.rideMapZoomLevel,
      cameraStatusesCollection: environment.cameraStatusesCollection,
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore(reducers),
    provideEffects(AuthEffect, BaseEffect),
    provideStoreDevtools({
      maxAge: 4, // Retains last 25 states
      logOnly: true, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
    }),
    provideRouterStore(),
    provideHttpClient(withInterceptors([requestDuplicatePreventionInterceptor, loaderInterceptor, httpClientInterceptor])),
    provideHttpClient(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order: 'normalize, customprimeflex, primeng, customPrimeng',
          },
        },
      },
    }),
    DatePipe,
  ],
};
